module.exports = __webpack_public_path__ + "static/media/news_head_bg_2.964fed64.jpg";